export const appConstants = {

    basicInfo: {
        email: { display: '', val: '' },
        phone: { display: '', val: '' }
    },
    baseTitle: 'AU Bank',
    minDate: new Date(new Date().getTime() + (86400000 * 3)),
    "titles": {
      "homepage_pagetitle": "Card Offers, Discounts and Deals - AU Small Finance Bank",
      "homepage_description": "Avail exciting card offers, deals and discounts on shopping, travel, health, wellness, etc. Check out all the various benefits offered by AU Bank Card. Click to know more.",
      "homepage_keywords": "au bank offers, card offers, card discounts, card deals, card privileges, special offers, travel offers, entertainment offers, business offers, shopping offers, dining offers, health and wellness offers, offers near me",
      "shopping_dhamaka_pagetitle": "AU Shopping Dhamaka - Exciting Offers & Discounts | AU Small Finance Bank",
      "shopping_dhamaka_description": "Festive Bank Offers - Shop with AU Bank Debit & Credit Cards and grab a Premium Smartphone, Gift Cards, Cashback along with exciting offers & discounts across top brands.",
      "shopping_dhamaka_keywords": "festive offers, bank offers, bank deals, bank discounts, card offers discount, cashback, credit card offers, debit card offers, diwali offer, bank diwali offer, shopping offers, festival shopping offers, festive shopping offers, au shopping dhamaka, au shopping dhamaka, ausd",
      "header_title": "",
      "modal_mobile_label": "Enter your mobile number registered with AU Bank",
      "modal_email_label": "Enter your email address registered with AU Bank",
      "card_name": "AU Small Finance Bank Debit Card",
      "platform_title": "AU Small Finance Bank",
      "concierge_name": "AU Small Finance Bank",
      "login_modal_control": "Opt in to receive offers & benefits"
    },
    contexualCardBg: {
        'cashbackFixed': {
            bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg1.png",
            bgColor: "linear-gradient(87.79deg, #F377B3 -23.62%, #FEB3DD 81.88%)",
            solidColorDark: "#F377B3",
            bottomColor: '#BC5050'
        },
        'cashbackPercent': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg2.png",
          bgColor: "linear-gradient(87.67deg, #F74D42 -66.26%, #FFE9B4 78.25%)",
          solidColorDark: "#F74D42",
          bottomColor: '#6c584c'
        },
        'annualBenefit': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg3.png",
          bgColor: "linear-gradient(85.5deg, #6A72F5 -14.65%, #CCF0FE 80.47%)",
          solidColorDark: "#6A72F5",
          bottomColor: '#5770c0'
        },
        'quaterlyBenefit': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg4.png",
          bgColor: "linear-gradient(88.32deg, #FF6F61 -17.54%, #F59F96 65.93%)",
          solidColorDark: "#FF6F61",
          bottomColor: '#8A8132'
        },
        'welcomeBenefit': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg6.png",
          bgColor: "linear-gradient(86.91deg, #C4B63F -12.32%, #F7E22C 76.67%)",
          solidColorDark: "#C4B63F",
          bottomColor: '#8A8132'
        },
        'welcomeBenefit4': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg5.png",
          bgColor: "linear-gradient(86.91deg, #504A80 -12.32%, #E2BDFF 76.67%)",
          solidColorDark: "#504A80",
          bottomColor: '#8A8132'
        },
        'singleOffer': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/contexual-b-bg7.png",
          bgColor: "linear-gradient(85.82deg, #DD7138 -14.9%, #EEC49F 94.19%)",
          solidColorDark: "#DD7138",
          bottomColor: '#ed5159'
        },
        'seeAll': {
          bgIcon: "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/all-campaign-bg.png",
          bgColor: "linear-gradient(77.97deg, #ADB5BD -12.6%, #F8F9FA 106.54%)",
          solidColorDark: "#ADB5BD",
          bottomColor: '#ed5159'
        },
    },
  imgCategoryMap:{
    shopping:{
      logo_url:'https://images.poshvine.com/categories/au-bank/shopping.svg'
    },
    'health-wellness':{
      logo_url:'https://images.poshvine.com/categories/au-bank/health.svg'
    },
    'silver-spoon':{
      logo_url:'https://images.poshvine.com/categories/au-bank/silver-spoon.svg'
    },
    'credit-card-emi-offers':{
      logo_url:'https://images.poshvine.com/categories/au-bank/credit-card.svg'
    },
    productivity:{
      logo_url:'https://images.poshvine.com/categories/au-bank/productivity.svg'
    },
    'small-business':{
      logo_url:'https://images.poshvine.com/categories/au-bank/small-business.svg'
    },
    travel:{
      logo_url:'https://images.poshvine.com/categories/au-bank/flight.svg'
    },
    'special-offers':{
      logo_url:'https://images.poshvine.com/categories/au-bank/special-offers.svg'
    },
    marketing:{
      logo_url:'https://images.poshvine.com/categories/au-bank/marketing.svg'
    },
    entertainment:{
      logo_url:'https://images.poshvine.com/categories/au-bank/entertainment.svg'
    },
    international:{
      logo_url:'https://images.poshvine.com/categories/au-bank/international.svg'
    },
    dining:{
      logo_url:'https://images.poshvine.com/categories/au-bank/dining.svg'
    },
    nearme:{
      logo_url:'https://images.poshvine.com/categories/au-bank/offers-nearme.svg'
    },
    'cloud-infrastructure':{
      logo_url:'https://images.poshvine.com/categories/au-bank/cloud-infra.svg'
    },
    'heart-to-cart':{
      logo_url:'https://images.poshvine.com/categories/au-bank/heart-to-cart.svg'
    }
  }
}

